class WatchlistDataProcessor {

    static mapValuesToObject(values, headers) {
        const obj = {};
        headers.forEach((header, index) => {
            obj[header] = values[index];
        });
        return obj;
    }

    static calculateStartPrices(data, sortedTimestamps, headers) {
        const startPrices = {};
        if (sortedTimestamps.length > 0) {
            const earliestTimestamp = sortedTimestamps[0];
            const earliestRows = data[earliestTimestamp];
            earliestRows.forEach(row => {
                const stockRaw = this.mapValuesToObject(row, headers);
                if (stockRaw.ticker) {
                    startPrices[stockRaw.ticker] = parseFloat(stockRaw.price);
                }
            });
        }
        return startPrices;
    }

    static applyHoldingToStock(stock, holding) {
        if (!holding) {
            stock.userHolding = null;
            return stock;
        }

        const quantity = parseFloat(holding.quantity) || 0;
        const totalCostBasis = parseFloat(holding.price) || 0; 
        const currentPrice = parseFloat(stock.price) || 0;

        if (quantity > 0) {
            const currentTotalValue = currentPrice * quantity;
            const totalValueChange = currentTotalValue - totalCostBasis;
            const totalPercentChange = totalCostBasis !== 0 ? (totalValueChange / totalCostBasis) * 100 : 0;

            stock.userHolding = {
                quantity,
                totalCostBasis,
                totalValueChange,
                totalPercentChange,
                currentTotalValue
            };
        } else {
            stock.userHolding = null;
        }

        return stock;
    }

    static createStockObject(stockRaw, startPrices, holdings = {}, tickerInfo = {}) {
        const currentPrice = parseFloat(stockRaw.price);
        const startPrice = startPrices[stockRaw.ticker] || currentPrice;

        const totalChangeDollar = currentPrice - startPrice;
        const totalChangePercent = startPrice !== 0 ? (totalChangeDollar / startPrice) * 100 : 0;
        
        const stock = {
            ticker: stockRaw.ticker,
            price: currentPrice,
            todaysChangePerc: parseFloat(stockRaw.price_pct_change_vs_prev_close),
            todaysChange: parseFloat(stockRaw.price_change_vs_prev_close),
            totalChangePercent: totalChangePercent,
            totalChangeDollar: totalChangeDollar,
            volume: parseFloat(stockRaw.volume),
            market_cap: parseFloat(stockRaw.market_cap) || 0,
            day: {
                c: currentPrice,
                v: parseFloat(stockRaw.volume)
            },
            tickerDetails: tickerInfo[stockRaw.ticker] || null,
            ...stockRaw
        };

        return this.applyHoldingToStock(stock, holdings[stockRaw.ticker]);
    }

    static processWatchlistReport(responseData, interval = '1d', holdings = {}, tickerInfo = {}) {
        if (!responseData || !responseData.response || !responseData.response.data || !responseData.response.headers) {
            console.error('[WatchlistDataProcessor] Invalid response structure', responseData);
            return { intervals: {}, stockInfo: {} };
        }

        const { headers, data } = responseData.response;
        const allTimestamps = Object.keys(data).sort((a, b) => new Date(a) - new Date(b));

        const startPrices = this.calculateStartPrices(data, allTimestamps, headers);
        const stockInfo = {};
        const intervals = {};

        for (const [timestamp, rows] of Object.entries(data)) {
            let cleanTimeKey = timestamp.replace(' EST', '').replace(' EDT', '').trim();
            cleanTimeKey = cleanTimeKey.replace('T', ' ').replace('Z', '').split('.')[0];
            
            intervals[cleanTimeKey] = rows.map(row => {
                const stockRaw = this.mapValuesToObject(row, headers);
                const stock = this.createStockObject(stockRaw, startPrices, holdings, tickerInfo);
                stock.timestamp = timestamp
                return stock;
            });
        }

        for (const timestamp of allTimestamps) {
            const rows = data[timestamp];
            rows.forEach(row => {
                const stockRaw = this.mapValuesToObject(row, headers);
                const stock = this.createStockObject(stockRaw, startPrices, holdings, tickerInfo);
                stockInfo[stock.ticker] = stock;
            });
        }

        return {
            intervals,
            stockInfo,
            metadata: {
                previous_close_date: Object.values(tickerInfo)[0]?.previous_close_date || ''
            }
        };
    }
}

window.WatchlistDataProcessor = WatchlistDataProcessor;
